export default function makeRenderBeachDetails(createSimplePrivateGallery, noBeachImageURL) {
    /**
     * Renderira informacije o plaži.
     *
     * @param {array} beachGallery Niz URL-ova slika plaže. Prva slika u nizu se smatra glavnom slikom plaže.
     * @param {array} beachDescriptions Niz opisa plaže prevedeni za traženi jezik. Prvi opis u nizu se smatra glavnim opisom plaže.
     *
     * @return {object} contentContainer HTML element koji sadrži sve pripadajuće elemente za prikaz informacija o plaži.
     */
    return function renderBeachDetails({ beachGallery, beachDescriptions }) {
        const contentContainer = document.createElement('div');

        if (beachGallery.length) {
            const galleryContent = getGalleryContent(beachGallery, beachDescriptions[0]);
            contentContainer.appendChild(galleryContent);
        } else {
            const noBeachImageElement = document.createElement('img');
            noBeachImageElement.setAttribute('src', noBeachImageURL);
            noBeachImageElement.setAttribute('alt', beachDescriptions[0]);
            contentContainer.appendChild(noBeachImageElement);
        }

        const descriptionsContent = getDescriptionsContent(beachDescriptions);
        contentContainer.appendChild(descriptionsContent);

        return contentContainer;
    };

    function getGalleryContent(beachGallery, mainBeachDescription) {
        const galleryImageElement = document.createElement('img');
        galleryImageElement.classList.add('currentImage');
        galleryImageElement.setAttribute('src', beachGallery[0]);
        galleryImageElement.setAttribute('alt', mainBeachDescription);

        const galleryPreviousButtonElement = document.createElement('span');
        galleryPreviousButtonElement.classList.add('simpleGalleryPrev');

        const galleryNextButtonElement = document.createElement('span');
        galleryNextButtonElement.classList.add('simpleGalleryNext');

        const galleryCounterElement = document.createElement('span');
        galleryCounterElement.classList.add('simpleGalleryCounter');

        const galleryContentContainer = document.createElement('figure');
        galleryContentContainer.classList.add('simpleGallery', 'beachInfoSimpleGallery');
        galleryContentContainer.appendChild(galleryImageElement);
        galleryContentContainer.appendChild(galleryPreviousButtonElement);
        galleryContentContainer.appendChild(galleryNextButtonElement);
        galleryContentContainer.appendChild(galleryCounterElement);

        // Za potrebe testa.
        if (process.env.NODE_ENV !== 'production') {
            galleryContentContainer.setAttribute('data-testid', 'gallery-content');
            galleryImageElement.setAttribute('data-testid', 'gallery-image');
            galleryPreviousButtonElement.setAttribute('data-testid', 'previous-button');
            galleryNextButtonElement.setAttribute('data-testid', 'next-button');
            galleryCounterElement.setAttribute('data-testid', 'gallery-counter');
        }

        createSimplePrivateGallery({
            source: beachGallery.map((beachImageURL) => ({ url: beachImageURL, alt: mainBeachDescription })),
            previousButton: galleryPreviousButtonElement,
            nextButton: galleryNextButtonElement,
            counterElement: galleryCounterElement,
            imageElement: galleryImageElement,
        });

        return galleryContentContainer;
    }

    function getDescriptionsContent(beachDescriptions) {
        const descriptionsContentContainer = document.createElement('div');

        // Za potrebe testa.
        if (process.env.NODE_ENV !== 'production') {
            descriptionsContentContainer.setAttribute('data-testid', 'description-content');
        }

        beachDescriptions.forEach((description) => {
            const beachDescriptionParagraphElement = document.createElement('p');
            beachDescriptionParagraphElement.classList.add('map-info-window-beach-description');
            beachDescriptionParagraphElement.textContent = description;
            descriptionsContentContainer.appendChild(beachDescriptionParagraphElement);
        });

        return descriptionsContentContainer;
    }
}
